<template>
  <div class="event-desc-link event-list">
    <ul :class="eventContentList.length > 1 ? 'event-row02' : 'event-row01'">
      <li
        v-for="(contentInfo, index) in eventContentList"
        :key="index"
      >
        <EventContent
          :content-info="contentInfo"
          :content-type="contentType"
        />
      </li>
    </ul>
  </div>
</template>
<script>
import EventContent from '@/components/customer/EventContent.vue'

export default {
  name: 'EventContentList',
  components: {
    EventContent
  },
  props: {
    eventContentList: {
      type: Array,
      default: () => []
    },
    contentType: {
      type: String, // movie | vod
      default: ''
    }
  }
}
</script>
